import React from 'react'
import { Container, Box, Grid, useMediaQuery, Typography, Card } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'
import { makeStyles } from '@material-ui/core/styles'
import { themeConWeb } from '@app/util/modernThemeConweb'

const useStyles = makeStyles({
  cardContainer: {
    backgroundColor: themeConWeb.color.white,
    width: '100%',
  },
  rowTitle: {
    fontWeight: 400,
  },
})

const HomeRowContainer = ({ loading, rowTitle, children, hideForDesktop }) => {
  const classes = useStyles()

  const desktopView = useMediaQuery(theme => theme.breakpoints.up('md'))

  const shouldShow = desktopView => {
    return desktopView ? !hideForDesktop : true
  }

  if (loading && shouldShow(desktopView)) {
    return <SkeletonLoading />
  } else if (!shouldShow(desktopView)) {
    return null
  }

  return (
    <Container maxWidth="lg">
      {rowTitle && (
        <Box padding={2}>
          <Typography className={classes.rowTitle} variant="h5">
            {rowTitle}
          </Typography>
        </Box>
      )}
      <Grid item md={9} xs={12}>
        <Grid container justifyContent="center">
          <Grid item md={11} xs={12}>
            <Box marginBottom={3}>{children}</Box>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  )
}

const SkeletonLoading = () => {
  return (
    <Container maxWidth="lg" data-testid="HomeRowSkeleton">
      <Box padding={2}>
        <Skeleton height={50} width={100} />
      </Box>
      <Grid item md={9} xs={12}>
        <Grid container justifyContent="center">
          <Grid item md={11} xs={12}>
            <Card padding={0}>
              <Box alignItems="center" display="flex" justifyContent="space-between" height={100}>
                <Skeleton height={150} width={150} />
                <Box>
                  <Skeleton height={30} width={150} />
                  <Skeleton height={30} width={150} />
                  <Skeleton height={30} width={150} />
                </Box>
                <Box>
                  <Skeleton height={30} width={50} />
                </Box>
              </Box>
            </Card>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  )
}

export default HomeRowContainer
